<button nz-button nz-tooltip nzTooltipTitle="Paziņojumu vēsture" nzType="info" (click)="openNotificationHistoryModal()">
    <span nz-icon nzType="bell" nzTheme="outline"></span>
</button>
